import React from 'react';
import { Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import GlassCard from '../../../ui/glass/components/GlassCard';
import usePermissions from '../../../hooks/usePermissions';

const formatCurrency = (amount) => (amount ?? 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
const formatDate = (timestamp) => timestamp ? timestamp.toDate().toLocaleDateString('tr-TR') : '---';

const ScheduledPaymentsTable = ({ pendingScheduledPayments, handleDeleteScheduledPayment }) => {
    const { canDelete } = usePermissions();

    if (pendingScheduledPayments.length === 0) return null;

    return (
        <GlassCard sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Planlanmış Tahsilatlar ({pendingScheduledPayments.length})</Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Vade Tarihi</TableCell><TableCell sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Açıklama</TableCell><TableCell sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Ödeme Yöntemi</TableCell><TableCell align="right" sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Tutar</TableCell><TableCell className="no-print" sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>İşlem</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {pendingScheduledPayments.map(p => (
                            <TableRow key={p.id} hover sx={{ transition: 'background-color 0.2s' }}>
                                <TableCell>{formatDate(p.vadeTarihi)}</TableCell>
                                <TableCell>{p.aciklama || '-'}</TableCell>
                                <TableCell>{p.odemeYontemi}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(p.tutar)}</TableCell>
                                <TableCell className="no-print">
                                    {canDelete() && (
                                        <Tooltip title="Planlanmış tahsilatı sil">
                                            <IconButton size="small" onClick={() => handleDeleteScheduledPayment(p.id)}>
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </GlassCard>
    );
};

export default ScheduledPaymentsTable;
